import * as React from "react";

const ChevronRightIcon = (props) => (
  <svg
    width={21}
    height={36}
    viewBox="0 0 21 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.118 1.887a3.25 3.25 0 0 0 0 4.583l11.505 11.667L1.118 29.642a3.25 3.25 0 0 0 2.307 5.544 3.25 3.25 0 0 0 2.308-.961l13.78-13.78a3.25 3.25 0 0 0 0-4.615L5.733 1.887a3.25 3.25 0 0 0-4.615 0Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronRightIcon;
